import React from "react";

type SidebarIconsProps = React.SVGProps<SVGSVGElement> & {
  color?: string;
};

export const SidebarIcons = ({
  width = 20,
  height = 20,
  color = "currentColor",
  ...props
}: SidebarIconsProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.7667 10.973H5.25319C4.92017 10.9749 4.60143 11.1085 4.36661 11.3446C4.1318 11.5808 3.99999 11.9003 4 12.2333V14.7468C4 15.0792 4.13203 15.3979 4.36705 15.6329C4.60207 15.868 4.92082 16 5.25319 16H7.7667C8.09967 16 8.41909 15.8682 8.65514 15.6333C8.89119 15.3985 9.02466 15.0798 9.02638 14.7468V12.2333C9.02638 11.8992 8.89366 11.5788 8.65743 11.3426C8.42119 11.1063 8.10079 10.9736 7.7667 10.9736M7.7667 4H5.25319C5.08862 4 4.92566 4.03241 4.77361 4.09539C4.62157 4.15837 4.48342 4.25068 4.36705 4.36705C4.25068 4.48342 4.15837 4.62157 4.09539 4.77361C4.03241 4.92566 4 5.08862 4 5.25319V7.7667C4 8.09967 4.13182 8.41909 4.36665 8.65514C4.60149 8.89119 4.92023 9.02466 5.25319 9.02638H7.7667C8.10079 9.02638 8.42119 8.89366 8.65743 8.65743C8.89366 8.42119 9.02638 8.10079 9.02638 7.7667V5.25319C9.02466 4.92023 8.89119 4.60149 8.65514 4.36665C8.41909 4.13182 8.09967 4 7.7667 4ZM14.7468 4H12.2333C11.9003 4 11.5809 4.13182 11.3449 4.36665C11.1088 4.60149 10.9753 4.92023 10.9736 5.25319V7.7667C10.9738 8.10074 11.1066 8.42104 11.3428 8.65724C11.579 8.89344 11.8993 9.02621 12.2333 9.02638H14.7468C15.0798 9.02466 15.3985 8.89119 15.6333 8.65514C15.8682 8.41909 16 8.09967 16 7.7667V5.25319C16 4.92082 15.868 4.60207 15.6329 4.36705C15.3979 4.13203 15.0792 4 14.7468 4ZM13.4865 10.973C12.8199 10.973 12.1805 11.2378 11.7092 11.7092C11.2378 12.1805 10.973 12.8199 10.973 13.4865C10.973 14.1531 11.2378 14.7924 11.7092 15.2638C12.1805 15.7352 12.8199 16 13.4865 16C14.1531 16 14.7924 15.7352 15.2638 15.2638C15.7352 14.7924 16 14.1531 16 13.4865C16 12.8199 15.7352 12.1805 15.2638 11.7092C14.7924 11.2378 14.1531 10.973 13.4865 10.973Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SidebarIcons;
